import React, { useEffect, useState } from "react";
import { Container, Card, Alert } from '@themesberg/react-bootstrap';
import { useSelector } from 'react-redux';
import axiosInstance from "../../api/api";
import BusinessModelRatingTable from "../../components/BusinessModelRatingTable";

export default () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const ciemId = useSelector(state => state.ciem.ciemId);

    useEffect(() => {
        const fetchRatingData = async () => {
            if (!ciemId) {
                setError("No se ha seleccionado un CIEM");
                setLoading(false);
                return;
            }

            try {
                const response = await axiosInstance.get(`/option/ciem/${ciemId}`);
                setData(response.data.data);
                setLoading(false);
            } catch (err) {
                setError(err.message || "Error al cargar los datos");
                setLoading(false);
            }
        };

        fetchRatingData();
    }, [ciemId]);

    if (!ciemId) {
        return (
            <Container className="mt-4">
                <Alert variant="warning">
                    Por favor, seleccione un CIEM para ver la calificación del modelo de negocio.
                </Alert>
            </Container>
        );
    }

    if (loading) {
        return (
            <Container className="mt-4">
                <Card className="text-center p-4">
                    <p>Cargando...</p>
                </Card>
            </Container>
        );
    }

    if (error) {
        return (
            <Container className="mt-4">
                <Alert variant="danger">
                    Error: {error}
                </Alert>
            </Container>
        );
    }

    return (
        <Container className="mt-4">
            <h2 className="mb-4">Calificación de mi modelo de negocio</h2>
            {data && <BusinessModelRatingTable data={data} />}
        </Container>
    );
};
